<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ایجاد یک آزمون آزاد جدید</h1>
          <b-form-group label="عنوان آزمون" label-for="title">
            <b-form-input
              id="title"
              v-model="examDetails.title"
              trim
              placeholder="ماضی استمراری"
            />
          </b-form-group>
          <exam-creation
            ref="examCreation"
            @getExamQuestions="setExamQuestions"
          ></exam-creation>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      examDetails: {
        isDeleted: false,
        publicExamId: 0,
        title: null,
        lessonId: null,
        creatorId: 1,
        createDate: new Date(Date.now()),
        examQuestions: [],
      },
    };
  },
  methods: {
    setExamQuestions(examQuestions) {
      this.examDetails.examQuestions = examQuestions;
      this.createAPublicExam();
    },
    async createAPublicExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let createAPublicExam = new CreateAPublicExam(_this);
        createAPublicExam.setRequestParamDataObj(_this.examDetails);
        await createAPublicExam.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "آزمون با موفقیت ایجاد شد",
                icon: "ClipboardIcon",
                variant: "success",
              },
            });
            _this.examDetails = {
              isDeleted: false,
              publicExamId: 0,
              title: null,
              lessonId: null,
              creatorId: 1,
              createDate: new Date(Date.now()),
              examQuestions: [],
            };
            _this.$refs.examCreation.resetQuestions();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormFile,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    ExamCreation,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormFile,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { CreateAPublicExam } from "@/libs/Api/PublicExam";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ExamCreation from "@/views/components/Exams/ExamCreation.vue";
</script>
